/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppError } from 'Components/AppError';
import React, { useCallback, useState } from 'react';
import { getAppText } from 'Utils/text';

const ErrorBoundary = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement<any> | null => {
  const [error, setError] = useState<Error | null>(null);

  const onError = useCallback((errorParam: Error) => setError(errorParam), []);

  if (error) {
    return (
      <AppError
        title={error.message || `${getAppText('misc.error.appError.unknown')}`}
        action={{
          label: `${getAppText('misc.error.appError.back')}`,
          onAction: () => setError(null),
        }}
      />
    );
  }

  return children
    ? React.cloneElement(children as React.ReactElement<any>, { onError })
    : null;
};

export default ErrorBoundary;
